import { render, staticRenderFns } from "./UcInvoiceFooter.yaml?vue&type=template&id=2e14a8aa&component"
import script from "./UcInvoiceFooter.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceFooter.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports